import React, { Component, Fragment } from 'react';
import { CSSTransition } from 'react-transition-group';

// helper functions
import * as func from '../../helpers/bodyScrollStyle';

// styles
import './slide-in.scss';

class SlideIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollPosition: null
    };
    this.closeModal = this.closeModal.bind(this);
    this.escFunction = this.escFunction.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
 
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.in === false && nextProps.in === true) {
      this.setState(
        {
          scrollPosition: window.pageYOffset
        },
        () => {
          func.activate(this.state.scrollPosition, this.props.isMenu);
        }
      );
    } else if (this.props.in === true && nextProps.in === false) {
      func.deactivate(this.state.scrollPosition, this.props.isMenu);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
    func.deactivate(this.state.scrollPosition, this.props.isMenu);
  }

  closeModal(keyCode) {
    this.props.close(keyCode);
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.closeModal(event.keyCode);
    }
  }

  render() {
    return (
      <Fragment>
        <CSSTransition
          in={this.props.in}
          classNames={'animation'}
          timeout={250}
          mountOnEnter
          unmountOnExit
        >
          <div
            role='button'
            tabIndex={0}
            aria-label='Close'
            className="slide-in__overlay"
            onClick={() => this.closeModal()}
            onKeyDown={(e) => this.closeModal(e)}
          />
        </CSSTransition>
        <CSSTransition
          in={this.props.in}
          classNames={'animation'}
          timeout={150}
          mountOnEnter
          unmountOnExit
        >
          <div className={`slide-in ${this.props.className}`}>
            {this.props.children}
          </div>
        </CSSTransition>
      </Fragment>
    );
  }
}

export default SlideIn;
